(() => {
    const searchInput = document.querySelector('.Search__Input');
    const toggleSearchButton = document.querySelector('[data-action="toggle-search"]');
    const newsletterEl = document.querySelector('.KlaviyoForm');

    if(newsletterEl) {
        window.validNewsSearchStrings = [
            'news',
            'newsl',
            'newsle',
            'newslet',
            'newslett',
            'newslette',
            'newsletter'
        ];

        /** news search manipulation **/
        let wait = false;
        searchInput.addEventListener('input', () => {
            if (validNewsSearchStrings.includes(searchInput.value.toLowerCase())) {
                if (!wait) {
                    wait = true;

                    setTimeout(() => {
                        wait = false;

                        // close search
                        toggleSearchButton.click()

                        // scroll to newsletter signup
                        const scrollOffset = newsletterEl.getBoundingClientRect().top + window.scrollY - (window.innerHeight / 2) + (newsletterEl.offsetHeight / 2);

                        window.scrollTo({
                            top: scrollOffset,
                            behavior: 'smooth'
                        });
                    }, 1000);
                }
            }
        });
    }
})();
